// extracted by mini-css-extract-plugin
module.exports = {"add":"SiteSettings_add__3Rew7","remove":"SiteSettings_remove__3roFp"};